module.exports = __webpack_public_path__ + "img/down_icon.d664d0a6.png";